import React from "react";
import { Box, Grid, Typography, Chip } from "@mui/material";

export default function Testimonial() {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 8 },
        maxWidth: 1400,
        mx: "auto",
      }}
    >
      <Grid container spacing={6} alignItems="center" justifyContent="center">
        {/* LEFT IMAGE */}
        <Grid
          item
          size={{ xs: 12, md: 4 }}
          display="flex"
          justifyContent="center"
        >
          <Box
            sx={{
              width: 260,
              height: 260,
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src="/img/store-owner.jpg"
              alt="Customer"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </Grid>

        {/* RIGHT CONTENT */}
        <Grid item size={{ xs: 12, md: 8 }}>
          {/* Badge */}
          <Chip
            label="↑ 15% increase in order value"
            sx={{
              mb: 2,
              backgroundColor: "#E8F5E9",
              color: "#2E7D32",
              fontWeight: 600,
              px: 1.5,
              py: 2,
              borderRadius: "12px",
            }}
          />

          {/* Quote */}
          <Typography
            sx={{
              fontSize: { xs: "1.6rem", md: "1.8rem" },
              fontWeight: 500,
              lineHeight: 1.3,
              mb: 3,
            }}
          >
            “With <strong>Truemenu POS (TPOS)</strong>, our team's efficiency has improved
            dramatically. Average order time is faster, and we've seen a notable
            increase in repeat customers.”
          </Typography>

          {/* Signature */}
          <Typography
            sx={{
              fontFamily: `"Dancing Script", cursive`,
              fontSize: "2rem",
              mb: 1,
            }}
          >
            Ammy J.
          </Typography>

          {/* Sub text */}
          <Typography color="text.secondary" fontSize="1.1rem">
            Owner, Urban Kitchen
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
